import { NewMessageForm } from '@components/Messages'
import { HEADER_CONTENT_TOP_SPACING } from '@constants/layout'
import { AppLayout } from '@layouts/AppLayout'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useToastController } from '@tamagui/toast'
import { Text, YStack } from 'tamagui'

type ToastType = 'success' | 'error'

export default function NewChannel() {
  const { t } = useTranslation('Messages')
  const toast = useToastController()

  const handleToast = useCallback(
    (type: ToastType, message: string) => {
      toast?.show?.(message, { type })
    },
    [toast],
  )

  return (
    <AppLayout backRoute={{ label: t('backToList') }}>
      <YStack
        marginTop={HEADER_CONTENT_TOP_SPACING}
        gap="$spacing-inset-md"
        paddingVertical="$spacing-inset-xs"
        paddingHorizontal="$size.spacing-xs"
        $gtSm={{ paddingHorizontal: '$size.spacing-xsl' }}
      >
        <Text
          fontFamily="$mulishBold"
          fontSize="$font-size-md"
          color="$accent"
          fontWeight="bold"
        >
          {t('new.title')}
        </Text>
        <NewMessageForm onToast={handleToast} />
      </YStack>
    </AppLayout>
  )
}
